<app-nav></app-nav>

<div class="content">
    <router-outlet></router-outlet>
</div>    

<div class="absolute z-[999] w-full h-full bg-white top-0 left-0 flex justify-center items-center" *ngIf="carica">
    <app-loading></app-loading>
</div>

<app-footer></app-footer>
<!-- <app-cookies></app-cookies> -->